import { createFileRoute } from '@tanstack/react-router';
import { Card, Loader, Stack, Switch, Text, Title } from '@mantine/core';
import { useCrudResource } from '@/shared/hooks/useCrudResource';
import type { Denormalized } from '@/shared/api/jsonapi/parser';

interface BlockNotification extends Denormalized {
  type: 'block-notifications';
  category?: string;
}

const CATEGORIES: Array<{ key: string; label: string; description: string }> = [
  { key: 'leave-request', label: 'Ferie e permessi', description: 'Approvazioni e cambi stato richieste' },
  { key: 'task-mention', label: 'Mention su task', description: 'Quando qualcuno ti menziona nei commenti' },
  { key: 'task-assignment', label: 'Task assegnati', description: 'Quando ti viene assegnato un task' },
  { key: 'smart-working', label: 'Smart Working', description: 'Approvazione richieste SW' },
  { key: 'vehicle-booking', label: 'Prenotazione mezzi', description: 'Conferme prenotazione auto' },
  { key: 'system', label: 'Sistema', description: 'Manutenzione, aggiornamenti, scadenze' },
];

export const Route = createFileRoute('/_app/settings/notification-preferences')({ component: NotifPrefsPage });

function NotifPrefsPage() {
  const crud = useCrudResource<BlockNotification>({
    resource: 'block-notifications',
    queryKey: ['block-notifications'],
    list: { page: { size: 100 } },
    labels: { create: 'Categoria bloccata', remove: 'Categoria riattivata' },
  });
  const blocked = new Set(crud.items.map((b) => b.category));

  const toggle = (cat: string, enabled: boolean) => {
    if (enabled) {
      const existing = crud.items.find((b) => b.category === cat);
      if (existing) crud.remove.mutate(existing.id);
    } else {
      crud.create.mutate({ attributes: { category: cat } });
    }
  };

  return (
    <Stack>
      <Title order={2}>Preferenze notifiche</Title>
      <Text c="dimmed" size="sm">Disabilita le categorie di notifiche che non ti interessano.</Text>
      <Card withBorder padding="lg" radius="md">
        {crud.isLoading ? <Loader size="sm" /> : (
          <Stack>
            {CATEGORIES.map((c) => {
              const enabled = !blocked.has(c.key);
              return (
                <Switch
                  key={c.key}
                  checked={enabled}
                  onChange={() => toggle(c.key, enabled)}
                  label={c.label}
                  description={c.description}
                />
              );
            })}
          </Stack>
        )}
      </Card>
    </Stack>
  );
}
